import React from "react"
import { API, graphqlOperation } from "aws-amplify"
import { Formik, Form } from "formik"
import { useSnackbar } from "notistack"
import { useRecoilState } from "recoil"
import { v4 as uuid } from "uuid"
import * as Yup from "yup"
import { makeStyles } from "@material-ui/core/styles"
// import Box from "@material-ui/core/Box"
// import FormHelperText from "@material-ui/core/FormHelperText"
import Grid from "@material-ui/core/Grid"
// import InputAdornment from "@material-ui/core/InputAdornment"
import Typography from "@material-ui/core/Typography"
import AddIcon from "@material-ui/icons/Add"
// import UploadIcon from "@material-ui/icons/CloudUpload"

import Layout from "../../components/AuthenticatedLayout"
import Button from "../../components/Button"
import Card from "../../components/Card"
import FormContainer from "../../components/FormContainer"
import TextAreaField from "../../components/TextAreaField"
import {
  createMessage as CreateMessage,
  // deleteMessage as DeleteMessage,
} from "../../graphqlCustom/mutations"
import { listMessages } from "../../graphqlCustom/queries"
import { onCreateMessagePool } from "../../graphqlCustom/subscriptions"
// import { sendEmail } from "../../graphqlCustom/queries"
// import createFile from "../../libs/createFile"
import { formatDate, toBase64 } from "../../libs/format" //, toBase64, bytesToSize
import currentAssociation from "../../store/currentAssociation"
import currentUser from "../../store/currentUser"

const useStyles = makeStyles((theme) => ({
  form: {
    "&:after": {
      clear: "both",
      content: "",
      display: "block",
    },
  },
  formTitle: {
    paddingLeft: theme.spacing(2),
  },
}))

// Email still needs to be set up

// const year = new Date().getFullYear()
// const fromEmail = "discussion@hi.condoaxis.com"
// const message = `
// Hey there,

// [fromName] has added a new message in [associationName]:

// [message]

// <a href="${window.location.origin.toString()}/0/discussion">${window.location.origin.toString()}/0/discussion</a>

// This email was sent to [toEmail], which is associated with a <a href="https://condoaxis.com">Condo Axis</a> account.

// &copy; ${year} Condo Axis Inc., All Rights Reserved
// Condo Axis Inc., 3805 N Lincoln Ave, Chicago, IL 60613
// `

// const emailMessage = (toEmail, fromEmail, fromName, associationName) => {
//   API.graphql(
//     graphqlOperation(sendEmail, {
//       from: fromEmail, //"messages@hi.condoaxis.com",
//       to: toEmail,
//       subject: `${fromName} has added a new message in ${associationName}`,
//       content: message
//         .replace(/\n/g, "<br/>")
//         .replace(/\[associationName\]/g, associationName)
//         .replace(/\[fromEmail\]/g, fromEmail)
//         .replace(/\[fromName\]/g, fromName)
//         .replace(/\[toEmail\]/g, toEmail),
//       replyTo: fromEmail,
//     })
//   )
// }

const maxAllowedSize = 10 * 1024 * 1024
const initialState = {
  messages: [],
}

function reducer(state, action) {
  switch (action.type) {
    case "SET_MESSAGES":
      return { ...state, messages: action.messages }
    case "ADD_MESSAGE":
      return { ...state, messages: [action.message, ...state.messages] }
    default:
      return state
  }
}

const Discussion = () => {
  const classes = useStyles()
  const { enqueueSnackbar } = useSnackbar()
  const [state, dispatch] = React.useReducer(reducer, initialState)

  const [association] = useRecoilState(currentAssociation)
  const [user] = useRecoilState(currentUser)

  React.useEffect(() => {
    async function fetchMessages() {
      try {
        if (!association.id) {
          return
        }
        const messages = await API.graphql(
          graphqlOperation(listMessages, {
            associationId: association.id,
            limit: 200,
            sortDirection: "DESC",
          })
        )
        if (messages.data && messages.data.listMessages.items.length) {
          dispatch({ type: "SET_MESSAGES", messages: messages.data.listMessages.items })
        }
      } catch (error) {
        console.log("error", error)
        enqueueSnackbar("Error fetching messages", {
          variant: "error",
        })
      }
    }
    fetchMessages()
    const subscription = API.graphql(graphqlOperation(onCreateMessagePool)).subscribe({
      next: (messageData) => {
        // const message = messageData.value.data.onCreateMessage
        const { onCreateMessagePool: message } = messageData.value.data
        if (message) {
          dispatch({ type: "ADD_MESSAGE", message })
        }
      },
    })
    return () => subscription.unsubscribe()
  }, [association, enqueueSnackbar])

  async function createMessage(message, files = null) {
    if (!message) return alert("Please add a message")

    const messageId = uuid()
    const submitData = {
      id: messageId,
      associationId: association.id,
      content: message,
      owner: user.id,
    }

    // await files.map(async (memo, file) => {
    //   await memo
    //   formData.append(
    //     file.name,
    //     new Blob((await toBase64(file)).split(""), {
    //       type: file.type,
    //     }),
    //     file.name
    //   )
    // }, undefined)

    try {
      // Add the message
      // const messageData =
      await API.graphql(graphqlOperation(CreateMessage, { input: submitData }))

      // console.log("files", files)
      // await files.forEach(async (file) => {
      //   if (file.filename) {
      //     await createFile(file, messageId, association.id)
      //   }
      // })

      enqueueSnackbar("Message added", {
        variant: "success",
      })
    } catch (error) {
      console.log("error", error)
      enqueueSnackbar(error.errors[0].message, {
        variant: "error",
      })
    }
  }

  return (
    <Layout title="Discussion">
      <FormContainer fullWidth>
        <Formik
          initialValues={{
            message: "",
            files: [],
          }}
          validationSchema={Yup.object().shape({
            message: Yup.string().required("Required"),
            files: Yup.mixed().test("file size", "File Size Exceeds 10MB", (files) => {
              if (!files) return true
              if (files.reduce((acc, file) => acc + file.size, 0) > maxAllowedSize) return false
              else return true
            }),
          })}
          onSubmit={async (values, { setErrors, setStatus, setSubmitting, resetForm }) => {
            try {
              createMessage(values.message, values.files || null)

              const formData = new FormData()
              if (values.files) {
                await values.files.reduce(async (memo, file) => {
                  await memo
                  formData.append(
                    file.name,
                    new Blob((await toBase64(file)).split(""), {
                      type: file.type,
                    }),
                    file.name
                  )
                }, undefined)
              }
              formData.append("name", `${user.firstName} ${user.lastName}`)
              formData.append("email", user.email)
              formData.append("phone", user.phone)

              // This needs the variables set up to finish
              // API.graphql(
              //   graphqlOperation(sendEmail, {
              //     from: "messages@hi.condoaxis.com",
              //     to: toEmail,
              //     subject: `${fromEmail} has invited you to join their Condo Axis home owner's association: ${associationName}`,
              //     content: message
              //       .replace(/\n/g, "<br/>")
              //       .replace(/\[inviteId\]/g, inviteId)
              //       .replace(/\[fromEmail\]/g, fromEmail)
              //       .replace(/\[toEmail\]/g, toEmail),
              //     replyTo: fromEmail,
              //   })
              // )

              resetForm({})
              setStatus({ success: true })
            } catch (error) {
              setStatus({ success: false })
              setErrors({ submit: error.message })
              console.error("error:", error.message)
            } finally {
              setSubmitting(false)
            }
          }}
        >
          {({ errors, handleBlur, handleChange, isSubmitting, touched, values, setFieldValue }) => (
            <Form className={classes.form}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Typography variant="h2" className={classes.formTitle}>
                    Add a Message
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <TextAreaField
                    error={Boolean(touched.message && errors.message)}
                    helperText={touched.message && errors.message}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.message}
                    label="Message"
                    variant="outlined"
                    size="medium"
                    name="message"
                    fullWidth
                    type="text"
                  />
                </Grid>
                {/* <Grid item xs={12}>
                  <Box mt={3}>
                    <Button
                      variant="outlined"
                      component="label"
                      color="primary"
                      fullWidth
                      size="large"
                      startIcon={<UploadIcon />}
                    >
                      Upload File
                      <input
                        type="file"
                        name="files"
                        onChange={(event) => setFieldValue("files", Array.from(event.target.files))}
                        style={{ display: "none" }}
                        multiple
                      />
                    </Button>
                    {errors.files ? (
                      <FormHelperText error>{errors.files}</FormHelperText>
                    ) : (
                      <FormHelperText>Max 10MB</FormHelperText>
                    )}
                    {values.files.length > 0 && (
                      <>
                        {values.files.map((file) => (
                          <FormHelperText>{file.name}</FormHelperText>
                        ))}
                        <FormHelperText>
                          Total Size:{" "}
                          {bytesToSize(
                            values.files.reduce((acc, file) => acc + file.size, 0),
                            "MB"
                          )}
                        </FormHelperText>
                      </>
                    )}
                  </Box>
                </Grid> */}
              </Grid>
              <Grid container spacing={3} justifyContent="flex-end">
                <Grid item>
                  <Button
                    className={classes.submit}
                    disabled={isSubmitting}
                    startIcon={<AddIcon />}
                    type="submit"
                    // onClick={handleSubmit}
                  >
                    Send
                  </Button>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </FormContainer>
      <FormContainer fullWidth transparent>
        {state.messages.length ? (
          state.messages.map((item, index) => {
            return (
              <Card key={index} className={classes.message}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Typography paragraph variant="body1">
                      {item.content}
                    </Typography>
                    <Typography variant="body2">
                      By: {item.author.firstName} {item.author.lastName} &lt;{item.author.email}&gt;
                      on {formatDate(item.createdAt)}
                    </Typography>
                  </Grid>
                </Grid>
              </Card>
            )
          })
        ) : (
          <h3>No messages yet.</h3>
        )}
      </FormContainer>
    </Layout>
  )
}

export default Discussion
